import IOdd from '../base/IOdd';
import SpecialMarketEvent from './SpecialMarketEvent';
import { OddStatus } from '../offer/enums';
import IBetSlipOdd from '../base/IBetSlipOdd';
import SpecialMarket from './SpecialMarket';

export interface ISpecialOdd extends IOdd {
    eventId: number;
    isLocked: boolean;
    isShownOnOffer: boolean;
}

export default class SpecialOdd implements IBetSlipOdd, ISpecialOdd {
    id: number;
    value: number;
    name: string;
    eventId: number;
    symbol = ''; // pro forma
    prefix = '';
    isInPromotion: false;
    isLocked: boolean;
    isShownOnOffer: boolean;

    private status: OddStatus;
    private parentMarketEvent: SpecialMarketEvent;
    private parentMarket: SpecialMarket;

    constructor(data: ISpecialOdd, parentMarketEvent: SpecialMarketEvent, parentMarket: SpecialMarket) {
        this.parentMarket = parentMarket;
        this.parentMarketEvent = parentMarketEvent;
        this.isLocked = data.isLocked;
        this.isShownOnOffer = data.isShownOnOffer;
        Object.assign(this, data);
    }

    get marketName() {
        return this.parentMarketEvent.name;
    }

    get code() {
        const fieldDefIndex = this.parentMarket.fieldDefinitions.indexOf(this.name);
        return this.parentMarket.enteringCodes[fieldDefIndex];
    }

    get marketCode() {
        return this.parentMarketEvent.code;
    }

    // used when serialized
    toJSON() {
        return {
            id: this.id,
            value: this.value,
        };
    }

    get specialBetValue() {
        return this.parentMarketEvent.specialBetValue || '';
    }

    get marketId() {
        return this.parentMarket.id;
    }

    get description() {
        return this.parentMarket.name;
    }

    get rules() {
        return this.parentMarketEvent.rules;
    }

    get isFinished() {
        return [
            OddStatus.finished,
            OddStatus.win,
            OddStatus.lost,
            OddStatus.refund
        ].includes(this.status);
    }

    get betStart() {
        return this.parentMarketEvent.betStart;
    }

    get betEnd() {
        return this.parentMarketEvent.betEnd;
    }

    get isBonusable() {
        return !this.isInPromotion;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/specials/SpecialOdd.ts